import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "container mt-4" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "row d-flex align-items-center mb-4" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-md-12 text-center" }, [
    /*#__PURE__*/_createElementVNode("h1", { class: "mb-4" }, "Annuity Contribution Detail"),
    /*#__PURE__*/_createElementVNode("p", null, "This reflects the detail of the amount shown on your Account Summary on the prior page.")
  ])
], -1)
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-primary col-md-2"
}, /*#__PURE__*/_toDisplayString(('Back')), -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TableComponent = _resolveComponent("TableComponent")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    ($setup.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, "Loading..."))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(_component_TableComponent, {
            PWHDs: $setup.PWHDs,
            totalDaysWorked: $setup.TotalDaysWorked,
            totalContributions: $setup.TotalContributions,
            headerNames: $setup.headerNames,
            sortOrder: $setup.sortOrder,
            onSortData: $setup.sortData
          }, null, 8, ["PWHDs", "totalDaysWorked", "totalContributions", "headerNames", "sortOrder", "onSortData"]),
          _createVNode(_component_router_link, {
            to: { name: 'annuity-summary', params: { year: $setup.year } }
          }, {
            default: _withCtx(() => [
              _hoisted_5
            ]),
            _: 1
          }, 8, ["to"])
        ]))
  ]))
}